export default "__VITE_ASSET__vmo4_ev0__"